<template lang="pug">
#dynamicAnswers.doNotDesactiveOnClick.dynamicAnswers(
    :class='{maybe: mayBeAllowed, open: open, noAnimation: noAnimation}', 
    @mouseleave='hide')
  .user(v-if='isUser')
    i.fa.fa-user.green(
      :title='$t("events.answers.user.present")', 
      :class='{selected: isYes, notSelected: !isYes}', 
      @click='setAnswer("Yes")')
    i.fa.fa-user.red(
      :title='$t("events.answers.user.absent")',
      :class='{selected: isNo, notSelected: !isNo}',
      @click='setAnswer("No")')
    i.fa.fa-user.orange(
      :title='$t("events.answers.user.maybe")',
      :class='{selected: isMaybe, notSelected: !isMaybe}', v-if='mayBeAllowed',
      @click='setAnswer("Maybe")')
    i.fa.fa-user(
      :title='$t("events.answers.user.noanswer")',
      :class='{selected: noAnswer, notSelected: !noAnswer}',
      @click='setAnswer(null)')
  .group(v-if='isGroup')
    i.fa.fa-group.green(
      :title='$t("events.answers.group.accepted")',
      :class='{selected: isYes, notSelected: !isYes}',
      @click='setAnswer("Yes")')
    i.fa.fa-group.red(
      :title='$t("events.answers.group.refused")',
      :class='{selected: isNo, notSelected: !isNo}',
      @click='setAnswer("No")')
    i.fa.fa-group(
      :title='$t("events.answers.group.noanswer")',
      :class='{selected: noAnswer, notSelected: !noAnswer}',
      @click='setAnswer(null)')
  .status(v-if='isStatus')
    i.fa.fa-check.green(
      :title='$t("events.answers.event.confirmed")',
      :class='{selected: isYes, notSelected: !isYes}',
      @click='setAnswer("CONFIRMED")')
    i.fa.fa-times.red(
      :title='$t("events.answers.event.refused")',
      :class='{selected: isNo, notSelected: !isNo}',
      @click='setAnswer("REFUSED")')
    i.fa.fa-question(
      :title='$t("events.answers.event.waiting")',
      :class='{selected: noAnswer, notSelected: !noAnswer}',
      @click='setAnswer("WAITING")')
</template>
<script>
import modalsBus from '@/components/shared/ModalsBus'

import $ from 'jquery'

import {mapGetters} from 'vuex'

export default {
  data () {
    return {
      subject: 'user',
      currentAnswer: null,
      event: null,
      mayBeAllowed: false,
      element: null,
      noAnimation: false,
      open: false
    }
  },
  mounted () {
    modalsBus.onOpen((arg, data) => {
      if (arg === modalsBus.modals.EDIT_ANSWER) {
        this.subject = data.subject
        if (this.subject === 'currentUser') {
          this.subject = this.user
        }
        this.currentAnswer = data.currentAnswer
        this.event = data.event
        this.element = data.element
        this.mayBeAllowed = data.event.hasMaybe
        this.noAnimation = data.quick
        this.show()
      } else {
        this.hide()
      }
    })
  },
  computed: {
    ...mapGetters('user', [
      'user'
    ]),
    isUser () {
      return this.subject !== 'group' && this.subject !== 'status'
    },
    isGroup () {
      return this.subject === 'group'
    },
    isStatus () {
      return this.subject === 'status'
    },
    isYes () {
      return this.currentAnswer === 'Yes' || this.currentAnswer === 'CONFIRMED'
    },
    isNo () {
      return this.currentAnswer === 'No' || this.currentAnswer === 'REFUSED'
    },
    isMaybe () {
      return this.currentAnswer === 'Maybe'
    },
    noAnswer () {
      return this.currentAnswer === null || this.currentAnswer === 'WAITING'
    }
  },
  methods: {
    setAnswer (answer) {
      if (this.isStatus) {
        if (this.event.status === answer) {
          return
        }
        this.$store.dispatch('events/putEventStatus', {id: this.event.id, status: answer})
        this.event.status = answer
      } else if (this.isGroup) {
        if (this.event.groupAnswer === answer) {
          return
        }
        this.$store.dispatch('events/putEventGeneralAnswer', {id: this.event.id, answer: answer, name: 'group'})
        this.event.groupAnswer = answer
      } else {
        if (this.event.answers[this.subject.id].answer === answer) {
          return
        }
        this.$store.dispatch('events/putEventAnswer', {event: this.event, answer: answer, user: this.subject})
        this.event.answers[this.subject.id].answer = answer
      }
      this.hide()
      this.$nextTick(() => $(window).trigger('resize'))
    },
    show () {
      let $thisEl = $(this.$el)
      let $element = $(this.element)
      $thisEl.css({
        'font-size': $element.css('font-size')
      })
      $('i', $thisEl).width($element.width()).height($element.height())
      let offset = $element.offset()
      offset.left = offset.left - ($('i:visible', $thisEl).outerWidth() - $element.outerWidth()) / 2
      offset.top = offset.top - ($('i:visible', $thisEl).outerHeight() - $element.outerHeight()) / 2
      $thisEl.css(offset)
      this.$nextTick(() => {
        setTimeout(() => {
          this.open = true // to ensure enough time for animation
        }, 1)
      })
      $('#body').on('scroll.answeringHover', () => {
        this.hide()
      })
      // a mouse move anywhere other than this element => hide
      $('#body').on('mousemove.answeringHover', (e) => {
        if ($(e.target).closest(this.$el).length + $(e.target).closest($thisEl).length === 0) {
          this.hide()
        }
      })
    },
    hide () {
      $('#body').off('.answeringHover')
      this.open = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// AnsweringHover.vue?5912ed6e